import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withFormik } from 'formik'
import { toast } from 'react-toastify';

import { withModalBuilder } from '../../../modules/modal/withModalBuilder'
import BulmaConfirmModal from '../../../modules/modal/BulmaConfirmModal'
import Field from '../../views/widgets/Field'
import InputText from '../../views/widgets/InputText'
import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import { sendMessageToTopic } from '../../../modules/portal-remote/portalService';


const NotificationControllerForm = ({
  onClose,
  handleSubmit,
  handleChange,
  isSubmitting,
  isValid,
  values,
  errors,
  touched,
}) => (
  <BulmaConfirmModal
    onClose={onClose}
    onConfirm={handleSubmit}
    isValid={isValid}
    isSubmitting={isSubmitting}
    headerTitle="ส่งข่าวสารให้ผู้ที่กดชื่นชอบไว้"
    confirmTitle="ส่งข้อความ"
  >
    {errors.flashMessage && (
      <div className="notification is-danger">{errors.flashMessage}</div>
    )}
    <Field label="หัวข้อ">
      <InputText
        name="title"
        value={values.title}
        error={errors.title}
        touched={touched.title}
        onChange={handleChange}
        disabled={isSubmitting}
      />
    </Field>

    <Field label="รายละเอียด">
      <InputText
        name="description"
        value={values.description}
        error={errors.description}
        touched={touched.description}
        onChange={handleChange}
        disabled={isSubmitting}
      />
    </Field>
  </BulmaConfirmModal>
)

const initialNotificationValues = () => ({
  title: '',
  description: '',
})

export default compose(
  connect(({ portal: { _id: portalId, notificationQuota } }) => ({
    portalId,
    notificationQuota,
  })),
  withModalBuilder({ isStatic: true }),
  withPortalAutoRemoteSync(),
  withFormik({
    mapPropsToValues: () => {
      return initialNotificationValues()
    },
    validate: values => {
      let errors = {}
      if (!values.title) {
        errors.title = 'Invalid title'
      }

      if (!values.description) {
        errors.description = 'Invalid description'
      }
      return errors
    },
    handleSubmit: async (values, { setSubmitting, props, setFieldError }) => {
      try {
        await sendMessageToTopic(
          props.portalId,
          `tpx.portal.${props.portalId}`,
          {
            title: values.title,
            body: values.description,
          },
        )
        setSubmitting(false)
        props.updatePortalAtPath(
          'notificationQuota',
          props.notificationQuota > 0 ? props.notificationQuota - 1 : 0,
        )
        toast.info("Send Message Completed !", {
          position: toast.POSITION.TOP_CENTER
        });
        props.onClose()
      } catch (error) {
        setSubmitting(false)
        setFieldError('flashMessage', `Can't send message ${error.message}`)
      }
    },
    isInitialValid: false,
    enableReinitialize: true,
  }),
)(NotificationControllerForm)



// WEBPACK FOOTER //
// ./src/components/templates/notification-controller/NotificationControllerModal.js